"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Label_1 = require("./Label");
const Label = (props) => {
    return (0, jsx_runtime_1.jsx)(Label_1.Label, Object.assign({}, props));
};
exports.Label = Label;
